import SelectAmong from './SelectAmong';

export default SelectAmong;